import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import CompanyEmployeeList from "../../components/CompanyEmployeeList";
import ProjectList from "../../components/ProjectList";
import CompanyForm from "../../components/forms/CompanyForm";
import FilesList from "../../components/FilesList";
import { FormMode } from "../../types/enums";
import { getFilesOfCompany } from "../../actions/companyActions";

const CompanyDetailPage = (props) => {
  return (
    <Page enableGoBack title="Bedrijf details">
      <CenteredPageContentContainer>
        <PaperContainer title="Gegevens van dit bedrijf" isAccordion={true}>
          <CompanyForm
            companyEmail={props.match.params.id}
            mode={FormMode.VIEW}
          />
        </PaperContainer>
      </CenteredPageContentContainer>
      <CenteredPageContentContainer>
        <PaperContainer title="Medewerkers van dit bedrijf">
          <CompanyEmployeeList company={props.match.params.id} />
        </PaperContainer>
      </CenteredPageContentContainer>
      <CenteredPageContentContainer>
        <PaperContainer title="Projecten van dit bedrijf" isAccordion={true}>
          <ProjectList company={props.match.params.id} />
        </PaperContainer>
      </CenteredPageContentContainer>
      <CenteredPageContentContainer>
        <PaperContainer title="Bestanden van dit bedrijf">
          <FilesList
            fileUploadEndpoint={`/company/${props.match.params.id}/file`}
            loadData={() => getFilesOfCompany(props.match.params.id)}
          />
        </PaperContainer>
      </CenteredPageContentContainer>
    </Page>
  );
};

CompanyDetailPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }),
};

export default CompanyDetailPage;



// WEBPACK FOOTER //
// ./src/pages/Company/CompanyDetailPage.js